import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a5db6b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sync-source-header" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "type" }
const _hoisted_6 = { class: "detail" }
const _hoisted_7 = {
  key: 0,
  class: "size"
}

import { computed } from 'vue'
import { FileIcon } from '@zhuowenli/vue-feather-icons'
import { ByteSizeUtil } from '@webapp/util/ByteSizeUtil'
import { SyncSourceInfo } from './SyncSessionModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncSourceHeader',
  props: {
    source: {},
    location: {}
  },
  setup(__props: any) {

const props = __props;



const sizeTextRef = computed(() => ByteSizeUtil.toReadableText(props.source.size))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.source.typeInfo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.source.typeInfo.icon,
            alt: _ctx.source.typeInfo.product
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createBlock(_unref(FileIcon), {
            key: 1,
            size: "40"
          }))
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.source.name), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.source.typeInfo?.description ?? 'Unknown file'), 1),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.location || _ctx.source.subtitle), 1),
    (_ctx.source.size != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(sizeTextRef.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})